import { Component, input } from '@angular/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-notification-number-label',
  imports: [],
  templateUrl: './onyx-notification-number-label.component.html',
  styleUrl: './onyx-notification-number-label.component.scss',
})
export class OnyxNotificationNumberLabelComponent {
  public readonly value = input.required<number>();
  public readonly color = input<OnyxColor>('red');
}
